// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".easyscreen-youtube{position:relative}.easyscreen-youtube--button{position:absolute;top:50%;left:50%;font-size:100px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.easyscreen-youtube--button,.easyscreen-youtube--button *{color:#fff!important}.easyscreen-youtube--button i{position:relative;top:2px}.easyscreen-youtube--overlay{position:absolute;top:0;left:0;right:0;bottom:0;z-index:99999}", ""]);
// Exports
module.exports = exports;
